module.exports = __webpack_public_path__ + "img/icon-account-logout@3x.6ca35887.png";